import ActionButton from "./ActionButton"
import Title from "../../Title"

const VideoShare = ({ shareVideo, isCaching, isDownloadDisabled }) => {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        gap: 12,
      }}
    >
      <Title title="Your Video is Ready" />

      <div
        css={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 24,
        }}
      >
        <div
          css={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 12,
          }}
        >
          <span
            css={{
              margin: 0,
              textAlign: "center",
              fontSize: 16,
              fontWeight: 500,
              lineHeight: 1.4,
              fontFamily: "Arial",
              color: "#d3dded",
            }}
          >
            Share your #Hologram
          </span>
        </div>
        <ActionButton
          label="Download Video"
          onClick={shareVideo}
          isCaching={isCaching}
          disabled={isDownloadDisabled}
        />
      </div>
    </div>
  )
}

export default VideoShare
